import React from 'react';
import AboutRyanPicture from './AboutRyan.jpg';
import './AboutRyan.css'

function AboutRyan() {
    return (
        <div className="Body-Content">
            <br /><br />
            <h1>About Ryan</h1>
            <br /><br />

            <div className="Blog">
            <img src={AboutRyanPicture} 
                    style={{width: '60%',
                    'justify-self': 'center',
                    'align-self': 'center'
                }}>

            </img>
            <br />
            <p>
                I’ve been coding since 2010 after I took a 
                computer science course in C.  I didn't think 
                I was cut out for coding because it took me hours to 
                figure out some of the most basic concepts.  
                But I absolutely loved it.  Now I code 
                for a living as a back end developer at 
                Applied Medical.
            </p>
                <p>
                    I was drum line captain in high school so 
                    I have a high rhythmic and musical background.  
                    I later translated those music leadership skills 
                    into the UCI Step Team that I founded known as 
                    Step Squad.  As a side hobby, I would also compete 
                    in Super Smash Bros Melee.  I was ranked 15th in
                    UCI during my last quarter there.  That might seem 
                    low, but UCI is the number 1 collegient team in that 
                    game.
                </p>
                <p>
                    During College I also started my career path in 
                    Information Technology in summer 2013 as a Network
                    Engineer Intern. It turns out that you need a good 
                    foundation of IT knowledge to understand computer 
                    networks.  This did give me a head start in my next 
                    job as the IT Administrative Assistant for the Child 
                    Abuse Prevention Center of Orange County, where my job 
                    was help desk support combined with IT Asset resource 
                    management.
                </p>
                <p>
                    I've had 2 other IT jobs after college.  One was at 
                    Active IT, where I learned how much smaller companies 
                    operate with their computer systems.  It was just a temp job and I 
                    might have been a bit over my head as they wanted a System 
                    Admin Level employee and I was just a fresh college graduate. 
                </p>
                <p>
                    After Active IT, I ended up getting a job at Applied Medical as 
                    a Junior Help Desk Technician.  This job wasn't difficult for me 
                    at all.  I wasn't very confident in myself and I didn't know how 
                    good of a technician I actually was until I came here.
                </p>
                <p>
                    I was able to solve people's problems in less than 5 minutes 
                    when similar issues would take other technicians 20 minutes or more.  
                    With my coding background, I was able to create scripts that would 
                    automate a lot of jobs for me.  
                    The extra time I had from solving issues 
                    quickly and automating jobs allowed me to focus on more coding.  
                    Next thing I knew I was coding a technician phone shift scheduler 
                    for our director (never got used as they'd rather manually do this.  
                    Don't ask me why...)   And then, I made my own project of displaying
                    on the downstairs TV who's scheduled for the phone shift, whih was 
                    automated by pulling the same calendar updated by the managers. 
                </p>
                <p>
                    I was given a task from my manager to assist one of the 
                    company's manufacturing teams with displaying the value of a 
                    Nitric Acid scale that was connected to the network.  After 
                    accomplishing that quickly, the team had a new request to 
                    automate emails to the team when the levels were low.  Then, 
                    they wanted a database that showed the levels of Nitric Acid 
                    each hour.  Eventually the app development team found out 
                    that I was coding for the manufacturing team and they stepped in 
                    to stop me as it wasn't my duty.  6 months later, that same team 
                    ended up asking me for some assistance on the project anyways.  
                </p>
                <p>
                    At around that time, the helpdesk director also asked me to 
                    initiate the service desk knowledge base (so helpdesk technicians 
                    would start doing things correctly and uniformly).  I was also 
                    the only person who could administer the OS Deployment Server so my 
                    manager at the time made me create a video tutorial on working.  
                </p>
                <p>
                    So yes, I had way too many responsibilities at one point and even 
                    though I am blessed to have learned so much in IT, I decided it was 
                    time to become a full time back-end developer.  Although I specialize 
                    in C# and .net back end server development, I've successfully finished 
                    more than 10 different web project.
                    
                </p>
            </div>
        </div>
    );
}

export default AboutRyan;